/**
 * Injeta script de terceiro com o nonce da CSP do portal (BACKEND.nonce), de forma assíncrona.
 * Falha de carregamento (ad blocker, rede) é silenciosa.
 */
export function injectScript(src) {
    if (document.querySelector(`script[src="${src}"]`)) {
        return;
    }

    const script = document.createElement("script");
    script.async = true;
    script.src = src;

    const nonce = typeof BACKEND !== "undefined" && BACKEND.nonce ? BACKEND.nonce : "";
    if (nonce) {
        script.setAttribute("nonce", nonce);
    }

    script.onerror = () => {};

    (document.head || document.body).appendChild(script);
}
